export const Banner = appName => {
  const dynamicPartner = ['Sts', 'SocietyForScienceBcm']
  let banner
  try {
    if (dynamicPartner.includes(appName)) {
      banner = require('./BannerDynamic')
    } else {
      banner = require('./Banner' + appName)
    }
  } catch (e) {
    banner = require('./Banner' + process.env.FALLBACK_APP_NAME)
  }
  return banner
}
